
export const initalState = {
  user: ''
};
const shop_reducer = (state = initalState, actions) => {
  switch (actions.type) {
    default:
      return state;
  }
};

export default shop_reducer;
